import { z } from "zod";
/**
 * Строки `corp_my_companies` / `corp_my_tariff` (контракт v2.0 §4.4, кабинет корп-админа, TECH-CORP-008).
 * `corp_my_companies` не отдаёт `credit_state`, итоги и даты (Q-D) — их читает staff-раздел (`v_corp_balances`).
 */
export const zCorpCompanySummaryRowDto = z.object({
    company_id: z.string(),
    name: z.string(),
    legal_name: z.string().nullish(),
    inn: z.string().nullish(),
    status: z.string(),
    credit_limit: z.number(),
    balance: z.number(),
    available_credit: z.number(),
    overdue_amount: z.number(),
    overdue_invoices_count: z.number(),
    open_orders_count: z.number(),
    open_orders_exposure: z.number(),
    billing_period: z.string(),
    invoice_issue_day: z.number(),
    payment_term_days: z.number(),
});
/** `corp_my_tariff` (§4.4) — пара тарифов ADVANCE/LATE активной компании. */
export const zCorpTariffRowDto = z.object({
    company_id: z.string(),
    id_advance: z.string(),
    name: z.string(),
    advance_price_per_kwh: z.number(),
    advance_one_time_fee: z.number(),
    late_price_per_kwh: z.number(),
    late_one_time_fee: z.number(),
    cutoff_hour_msk: z.number(),
    cutoff_offset_days: z.number(),
});
